import React, { Component } from "react";
import Stepper from "./Stepper/Stepper";
import ContributorForm from "./ContributorForm/ContributorForm";
import EstimatedCost from "./EstimatedCost/EstimatedCost";
import Beneficiaries from "./Beneficiaries/Beneficiaries";
import "./Quoter.less";
import Schedule from "./Schedule/Schedule";
import AppointmentCreated from "./AppointmentCreated/AppointmentCreated";

class Quoter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      contributor: null,
      beneficiaries: [],
      planType: "Individual",
      idCotization: null,
      totalCostCotization: 0,
      selectedDate: null,
      selectedHour: null,
    };
  }

  steps = ["Datos personales", "Añadir beneficiario", "Contacto con asesor"];

  changeStep = (step) => {
    if (step >= 1 && step <= this.steps.length + 1) {
      this.setState({ currentStep: step });
    }
  };

  handleSelectedDateChange = (selectedDateUpdated) => {
    this.setState({ selectedDate: selectedDateUpdated });
  };

  handleSelectedHourChange = (selectedHourUpdated) => {
    this.setState({ selectedHour: selectedHourUpdated });
  };

  handleTotalCostChange = (updatedCost) => {
    this.setState({ totalCostCotization: updatedCost });
  };

  handleContributorChange = (updatedContributor) => {
    // Calcular la edad a partir de birthDate
    const birthDate = new Date(updatedContributor.birthDate);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();

    // Ajuste si el cumpleaños aún no ha ocurrido en este año
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    const finalAge = hasBirthdayPassed ? age : age - 1;

    // Si la persona tiene 60 años o más, actualizar planType a "Mayores" - Cambio a individual consultar
    if (finalAge >= 60) {
      this.setState({ planType: "Individual" });
    }

    this.setState({ contributor: { ...updatedContributor, age: finalAge } });

    this.changeStep(2);
  };

  handleBeneficiariesChange = (updatedBeneficiaries) => {
    const beneficiariesWithAge = updatedBeneficiaries.map((beneficiary) => {
      const birthDate = new Date(beneficiary.birthDate);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();

      // Ajuste si aún no ha pasado su cumpleaños este año
      const hasHadBirthday =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() >= birthDate.getDate());

      const finalAge = hasHadBirthday ? age : age - 1;

      return {
        ...beneficiary,
        age: finalAge,
      };
    });

    const hasFamilyMember = beneficiariesWithAge.some(
      (beneficiary) => beneficiary.age >= 0 && beneficiary.age <= 59
    );

    this.setState({ beneficiaries: beneficiariesWithAge });

    if (hasFamilyMember) {
      this.setState({ planType: "Individual" });
    }
  };

  handleCotizationChange = (idCotization) => {
    this.setState({ idCotization });
  };

  render() {
    const {
      currentStep,
      contributor,
      beneficiaries,
      idCotization,
      totalCostCotization,
      selectedDate,
      selectedHour,
    } = this.state;

    return (
      <div className="main-container">
        <div className="quoter">
          <Stepper steps={this.steps} currentStep={currentStep} />
          <hr className="divider-dashed" />

          <div
            className={`step-content ${currentStep === 1 ? "active" : "hidden"
              }`}
          >
            <ContributorForm
              contributor={contributor}
              onContributorChange={this.handleContributorChange}
              idCotization={idCotization}
              onCotizationChange={this.handleCotizationChange}
            />
          </div>

          <div
            className={`step-content ${currentStep === 2 ? "active" : "hidden"
              }`}
          >
            <Beneficiaries
              beneficiaries={beneficiaries}
              onBeneficiariesChange={this.handleBeneficiariesChange}
              onNextStep={this.changeStep}
            />
          </div>
          <div
            className={`step-content ${currentStep === 3 ? "active" : "hidden"
              }`}
          >
            <Schedule
              contributor={contributor}
              beneficiaries={beneficiaries}
              idCotization={idCotization}
              totalCostCotization={totalCostCotization}
              onSelectedDateChange={this.handleSelectedDateChange}
              onSelectedHourChange={this.handleSelectedHourChange}
              onNextStep={this.changeStep}
            />
          </div>
          <div
            className={`step-content ${currentStep === 4 ? "active" : "hidden"
              }`}
          >
            <AppointmentCreated
              selectedDate={selectedDate}
              selectedHour={selectedHour}
            />
          </div>
        </div>
        <div className="costs">
          <EstimatedCost
            contributor={contributor}
            beneficiaries={beneficiaries}
            planType={this.state.planType}
            onCostChange={this.handleTotalCostChange}
          />
        </div>
      </div>
    );
  }
}

export default Quoter;
